import { cardBeforeEnterHandler } from '@/router/utilities/cardRouteHandler';
import { EpicTabId } from '@/types/tabs';
import constants from '@/utilities/constants';

export default async function (store: any, router: any, _to: any, _from: any, next: any) {
  // Check if epic feature flag is enabled
  await store.dispatch('getAllTeamFeatures');

  const { featureFlagIds } = constants;
  const hasEpicFeature = store.getters.getTeamFeatureEnabled(featureFlagIds.roadmapAndProjects);

  // Redirect to paywalled roadmap if epic feature is not enabled
  if (!hasEpicFeature) {
    return next({
      name: constants.epicsBoardRoute.name,
      params: { team_subdomain: _to.params.team_subdomain },
    });
  }

  if (
    !_to.params.selectedTabId ||
    Object.values(EpicTabId).indexOf(_to.params.selectedTabId as EpicTabId) === -1
  ) {
    _to.params.selectedTabId = store.getters.getEpicSelectedTabId(_to.params.cardId);
  }

  if (_to.params.selectedTabId) {
    store.dispatch('setEpicSelectedTabId', {
      cardId: _to.params.cardId,
      tabId: _to.params.selectedTabId,
    });
  }

  return cardBeforeEnterHandler(store, router, _to, _from, next);
}
